import { render, staticRenderFns } from "./YesNavbarClassic.vue?vue&type=template&id=540a8014&scoped=true&"
import script from "./YesNavbarClassic.vue?vue&type=script&lang=js&"
export * from "./YesNavbarClassic.vue?vue&type=script&lang=js&"
import style0 from "./YesNavbarClassic.vue?vue&type=style&index=0&id=540a8014&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540a8014",
  null
  
)

export default component.exports